import {branchCodes} from '../constants/branch-codes';
import {DEFAULT_BRANCH} from '../constants/constants';

export const branchHelper = (userGroups) => {

  const branchInfos = JSON.parse(branchCodes);

  const userBranches = userGroups.length > 0 ? branchInfos.filter(branchInfo =>
    userGroups.includes(branchInfo.sgId),
  ) : [];

  return userBranches.length > 0 ? userBranches.map(branchInfo => branchInfo.warehouseId) : [DEFAULT_BRANCH];
};